import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Icon } from "antd";
import React from "react";
export var Legends = function (_a) {
    var list = _a.list;
    return (React.createElement("div", { className: "background-gray-1 legends-holder" }, list.map(function (item, index) {
        return React.createElement("div", { key: index, className: "legends-item" },
            React.createElement(Icon, { className: "color-".concat(item.color), component: function () { return React.createElement(FontAwesomeIcon, { size: 'sm', icon: item.icon }); } }),
            React.createElement("span", { style: { marginLeft: '8px' } }),
            item.title);
    })));
};
//# sourceMappingURL=legends.js.map